module.exports = __webpack_public_path__ + "img/31.32390252.png";